<template>
  <div
    class="fixed flex items-center justify-center"
    style="
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 9999;
    "
  >
    <ValidationObserver ref="observer" rules="required" v-slot="{ handleSubmit }">
      <Card
        class="p-5 flex flex-col max-w-md"
        style="min-width: 448px; max-height: 750px; overflow-y: auto"
      >
        <div class="p-1 flex justify-between items-center mb-3">
          <span
            style="font-size: 10px"
            class="font-black flex flex-grow text-romanSilver uppercase"
          >
            Filters
          </span>
          <div  @click="clearFields" class="cursor-pointer">
            <Icon
              class-name="text-darkPurple mx-auto self-center"
              size="xs"
              icon-name="undo"
            />
          </div>
        </div>
        <divider class="flex-grow w-auto" />

        <div v-if="showSearch" class="flex p-1 mt-3">
          <SearchInput
            :placeholder="searchPlaceHolder"
            v-model="handleSearch"
            @input="searchFilter($event)"
            class="search"
            style="width: 100%; margin-top: 0.1rem"
          />
        </div>

        <div
          class="flex flex-col p-2 mt-5 border border-dashed"
          v-for="(data, index) in filterData"
          :key="index"
        >
          <div class="flex mb-2">
            <span
              style="font-size: 10px"
              class="font-black flex flex-grow text-romanSilver"
            >
              <span class="uppercase">Filter By :</span>
              <span
                class="ml-2 -mt-1 text-sm text-flame"
                style="font-weight: 400"
                >{{ data.header }}</span
              >
            </span>
          </div>
          <divider class="flex-grow w-auto" />
          <div class="w-full flex mb-2">
            <CSelect v-if="!('checked' in data) && !data.isMultiple"
              :placeholder="`--Select ${data.header}--`"
              :options="data.optionsBox"
              v-model="selectedValues[data.value]"
              @input="validateSelection($event, data.value)"
              variant="w-full h-10"
              class="h-10 w-full mx-2 my-1"
            />

            <v-select v-if="data.isMultiple && !('checked' in data)"
              :clearable="true"
              class="w-full mx-2 my-1"
              :placeholder="`--Select ${data.header}--`"
              multiple
              :options="data.optionsBox"
              :close-on-select="false"
              :label="data.optionLabel || 'name'"
              :reduce="data.optionValue ? (option) => option[data.optionValue] : (option) => option.id || option"
              v-model="selectedValues[data.value]"
              @input="validateSelection($event, data.value)"
            >
              <template #selected-option="{ name }">
                {{ name }}
              </template>
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <Icon icon-name="caret-down" size="xsm" />
                </span>
              </template>
            </v-select>

            <v-select v-if="'checked' in data"
              :clearable="false"
              class="w-full mx-2 my-1"
              :placeholder="`--Select ${data.header}--`"
              multiple
              :options="data.optionsBox"
              :close-on-select="false"
              label="name"
              :reduce="checked => checked.id"
              v-model="checked"
            >
              <template #option="{ name, id }">
                <div class="flex" @click.stop.prevent="togglePayrun(id, data.value)">
                  <div>
                    <div class="flex justify-start items-center gap-2">
                      <Checkbox 
                        checkbox-size="height:16px; width:16px"
                        @change.stop
                        :true-value="!isChecked(id)"
                        :key="id"
                      />
                      <span class="font-bold text-base cursor-pointer">{{ name }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <template #selected-option="{name}">
                {{ name }}
              </template>
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <Icon icon-name="caret-down" size="xsm" />
                </span>
              </template>
            </v-select>
          </div>
        </div>

        <div class="mt-10">
          <div class="flex flex-grow">
            <Button
              :class="disableBtn && `btn-disabled`"
              :disabled="disableBtn"
              :background="appearance.buttonColor || defaultBTNColor"
              :style="disableBtn ? `color: #878E99` : `color: #FFFFFF`"
              width="8rem"
              @click="disableBtn ? '' : handleSubmit(submit)"
            >
              {{ submitText }}
            </Button>
            <Button
              background-color="none"
              class="ml-4"
              style="color: #321c3b"
              @click="closeModal()"
            >
              Cancel
            </Button>
          </div>
        </div>
      </Card>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ValidationObserver } from "vee-validate";
import VSelect from "vue-select"
import "vue-select/dist/vue-select.css"
import SearchInput from "@scelloo/cloudenly-ui/src/components/search-input";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import Checkbox from "./Checkbox"
import Button from "@/components/Button";
import Card from "./Card";
import Divider from "./divider";

export default {
  name: "FilterTable",
  components: {
    ValidationObserver,
    Card,
    CSelect,
    Checkbox,
    VSelect,
    Divider,
    Button,
    SearchInput,
  },
  props: {
    filterData: {
      type: Array,
      default: () => [],
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    searchPlaceHolder: {
      type: String,
      default: "First, Last Name or Email",
    },
    submitText: {
      type: String,
      default: "Apply",
    },
    validation: {
      type: Boolean,
      default: false,
    },
    initialValues: {
      type: Object,
      default: () => ({})
    },
    initialSearch: {
      type: String,
      default: ""
    },
    initialChecked: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      queryParams: [],
      disableBtn: true,
      handleSearch: "",
      keysSelected: [],
      queryOptions: [],
      checked: [],
      selectedValues: {}
    };
  },
  computed: {
    ...mapState({
      defaultBTNColor: (state) => state.orgAppearance.defaultBtnColor,
      appearance: (state) => state.orgAppearance.orgAppearanceData,
    }),
  },
  watch: {
    filterData: {
      immediate: true,
      deep: true,
      handler(newData) {
        newData.forEach((filter) => {
          if (!('checked' in filter)) {
            const savedValue = this.initialValues[filter.value];
            if (filter.isMultiple) {
              this.$set(this.selectedValues, filter.value, savedValue || []);
            } else {
              this.$set(this.selectedValues, filter.value, savedValue !== undefined && savedValue !== null ? savedValue : null);
            }
          }
        });
        this.$nextTick(() => {
          this.restoreSavedValues();
        });
      }
    },
    initialValues: {
      immediate: true,
      deep: true,
      handler(newValues) {
        this.$nextTick(() => {
          this.restoreSavedValues();
        });
      }
    },
    'filterData': {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.restoreSavedValues();
        });
      }
    },
    initialSearch: {
      immediate: true,
      handler(newSearch) {
        if (newSearch !== undefined && newSearch !== null && newSearch !== "") {
          this.handleSearch = newSearch;
        }
      }
    },
    initialChecked: {
      immediate: true,
      deep: true,
      handler(newChecked) {
        if (newChecked && newChecked.length > 0) {
          this.checked = [...newChecked];
        }
      }
    }
  },
  mounted() {
    this.restoreSavedValues();
    this.updateButtonState();
  },
  methods: {
    restoreSavedValues() {
      this.$nextTick(() => {
        if (Object.keys(this.initialValues).length > 0) {
          Object.keys(this.initialValues).forEach((key) => {
            const savedValue = this.initialValues[key];
            if (savedValue !== undefined && savedValue !== null) {
              this.$set(this.selectedValues, key, savedValue);
            }
          });
        }
        if (this.initialSearch) {
          this.handleSearch = this.initialSearch;
        }
        if (this.initialChecked && this.initialChecked.length > 0) {
          this.checked = [...this.initialChecked];
        }
        this.updateButtonState();
      });
    },
    updateButtonState() {
      const hasSearchValue = this.handleSearch && this.handleSearch.trim() !== "";
      const hasSelectedValues = Object.keys(this.selectedValues).some(key => {
        const value = this.selectedValues[key];
        if (Array.isArray(value)) {
          return value.length > 0;
        }
        return value !== null && value !== undefined && value !== "";
      });
      const hasCheckedValues = this.checked && this.checked.length > 0;

      const hasAnyValue = hasSearchValue || hasSelectedValues || hasCheckedValues;

      if (this.validation) {
        const requiredFieldsCount = this.filterData.filter(f => !('checked' in f)).length;
        const filledFieldsCount = Object.keys(this.selectedValues).filter(key => {
          const value = this.selectedValues[key];
          if (Array.isArray(value)) {
            return value.length > 0;
          }
          return value !== null && value !== undefined && value !== "";
        }).length;
        this.disableBtn = filledFieldsCount < requiredFieldsCount && !hasSearchValue;
      } else {
        this.disableBtn = !hasAnyValue;
      }
    },
    clearFields() {
      this.filterData.forEach((filter) => {
        if (!('checked' in filter)) {
          if (filter.isMultiple) {
            this.$set(this.selectedValues, filter.value, []);
          } else {
            this.$delete(this.selectedValues, filter.value);
          }
        }
      });

      this.checked = [];
      this.handleSearch = "";
      this.queryParams = [];
      this.queryOptions = [];
      this.keysSelected = [];
      this.disableBtn = true;

      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }

      this.$emit("stateChange", {
        selectedValues: {},
        handleSearch: "",
        checked: []
      });

      this.$emit("getParams", "");
    },
    isChecked(id) {
      return this.checked.includes(id);
    },
    togglePayrun(id, key) {
      const index = this.checked.findIndex(check => check === id);
      if (index > -1) {
        this.checked.splice(index, 1); // uncheck
        this.validateSelection(this.checked, key)
      } else {
        this.checked.push(id); // check
        this.validateSelection(this.checked, key)
      }
    },
    validateSelection(value, key) {
      if (this.keysSelected.includes(key)) {
        const position = this.keysSelected.indexOf(key, 0);

        this.queryParams.splice(position, 1);
        this.queryOptions.splice(position, 1);
        this.keysSelected.splice(position, 1);
      }

      if (Array.isArray(value)) {
        if (value.length > 0) {
          const valueString = value.join(',');
          this.queryParams.push(`&${key}=${valueString}`);
          this.queryOptions.push({ [key]: valueString });
          this.keysSelected.push(key);
        }
      } else if (value !== null && value !== undefined && value !== '') {
        this.queryParams.push(`&${key}=${value}`);
        this.queryOptions.push({ [key]: value });
        this.keysSelected.push(key);
      }

      this.updateButtonState();
    },

    searchFilter(val) {
      this.updateButtonState();
    },

    closeModal() {
      this.$emit("close", true);
    },

    submit() {
      if (this.handleSearch !== "") {
        this.queryParams.push(`&search=${this.handleSearch}`);
      }
      const params = this.queryParams.join("").replace(/^&/, "");
      this.$emit("getParams", params);

      this.$emit("applyFilter", this.queryOptions);

      this.$emit("stateChange", {
        selectedValues: { ...this.selectedValues },
        handleSearch: this.handleSearch,
        checked: [...this.checked]
      });
    },
  },
};
</script>

<style>
.btn-disabled {
  background-color: #eeeeee;
  font-size: 16px;
}
</style>